import { mostRecentMatrixJobs, useJobsForStep } from "~/components/build/Show/lib/BuildContext";
import { CommandStep } from "~/lib/pipeline";
import Emojify from "~/components/shared/Emojify";
import { JobPillLink } from "~/components/build/Show/components/StepDrawer/JobPillLink";
import { CommandJob } from "~/components/build/Show/lib/types";
import { sortByState } from "~/components/build/Show/components/TableView/TableCell";

interface Props {
  step: CommandStep;
  jobs?: CommandJob[];
}

export const MatrixStepDetails = ({ step, jobs }: Props) => {
  const matrixJobs = jobs || useJobsForStep<CommandJob>(step.uuid);
  const recentMatrixJobs = mostRecentMatrixJobs(matrixJobs).sort(sortByState("asc"));

  return (
    <div className="flex min-w-0 flex-auto flex-col gap-2 pb-2">
      <div className="flex flex-wrap gap-1.5">
        {recentMatrixJobs.map((job) => {
          const name = job.name || job.command || "";

          return (
            <JobPillLink job={job} key={job.id}>
              <Emojify text={name} className="max-w-full truncate font-medium" />
            </JobPillLink>
          );
        })}
      </div>
    </div>
  );
};
